// src/pages/PortfolioPage.jsx
import Navbar from "../components/Navbar";
import Gallery from "../components/Gallery";
import { HeroSectionPortfolio } from "../components/HeroSection";
import Footer from "../components/Footer";
import "./styles/PortfolioPage.css";
import data from "../data/imageData.json";
import ResponsiveImage from "../components/ResponsiveImage";

const PortfolioPage = () => {
  return (
    <div className="portfolioPage">
      <div className="header">
        <ResponsiveImage src={data.portfoliopage.url} alt="" className="heroImage" priority />
        <Navbar />
        <HeroSectionPortfolio />
      </div>

      <main className="content">
        <Gallery />
      </main>

      <Footer />
    </div>
  );
};

export default PortfolioPage;
